import { PipesModule } from './../../common/pipes/pipes.module';
import { DirectivesModule } from './../../common/directives/directives.module';
import { InventoryComponent } from './inventory.component';
import { FormsModule } from '@angular/forms';
import { InventoryService } from './../../api/inventory/inventory.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list/list.component';
import { DetailComponent } from './detail/detail.component';
import { InventoryRoutingModule } from './inventory-routing.module';
import { CreateComponent } from './create/create.component';
import { EditComponent } from './edit/edit.component';
import { LocationService } from '../../api/location/location.service';
import { DestinationService } from '../../api/destination/destination.service';
import { AppCommonModule } from '../../common/common.module';
import { BatchComponent } from './batch/batch.component';
import { ScanRackComponent } from './scan-rack/scan-rack.component';
import { StorageComponent } from './storage/storage.component';
import { EventComponent } from './event/event.component';

@NgModule({
  imports: [
    CommonModule,
    InventoryRoutingModule,
    FormsModule,
    DirectivesModule,
    PipesModule
  ],
  providers: [InventoryService, LocationService, DestinationService],
  declarations: [
    InventoryComponent,
    ListComponent,
    DetailComponent,
    CreateComponent,
    EditComponent,
    BatchComponent,
    ScanRackComponent,
    StorageComponent,
    EventComponent,
  ]
})
export class InventoryModule {}
